export default "__VITE_ASSET__DpcQqZYN__"